export default {
  // BUYBOX
  buy_box_review: null,
  buy_box_reviews: null,
  buy_box_add_review: null,
  buy_box_color: null,
  buy_box_size: null,
  buy_box_unique_size: null,
  buy_box_btn_size_guide: null,
  buy_box_select_size: null,
  buy_box_no_selected_size: null,
  buy_box_out_of_stock: null,
  buy_box_btn_add_to_cart: null,
  buy_box_delivery: null,
  buy_box_returns: null,
  buy_box_loyaltypoints: null,
  // PRODUCT DETAILS
  product_details_title: null,
  product_details_style_code: null,
  product_details_color_code: null,
  product_details_features_title: null,
  // SIZE & FIT
  size_fit_title: null,
  size_fit_top_cut: null,
  size_fit_bottom_cut: null,
  size_fit_fit_intention: null,
  size_fit_fit_details: null,
  size_fit_waist_type: null,
  size_fit_leg_shape: null,
  size_fit_thickness: null,
  size_fit_back_length: null,
  size_fit_inside_leg_measurement: null,
  size_fit_centimeter: null,
  size_fit_inche: null,
  size_fit_millimeter: null,
  size_fit_dimensions: null,
  size_fit_dimensions_width: null,
  size_fit_dimensions_height: null,
  size_fit_dimensions_depth: null,
  size_fit_dimensions_top_handle_drop_length: null,
  size_fit_dimensions_adjustable_shoulder_strap_drop_length: null,
  size_fit_dimensions_strap_length: null,
  size_fit_dimensions_capacity: null,
  size_fit_model_size_data: null,
  // MATERIAL & CARE
  material_care_title: null,
  material_care_composition: null,
  material_care_down_percentage: null,
  material_care_down_fill_power: null,
  material_care_care_instructions: null,
  material_care_care_instructions_list: null,
  // FITTING GUIDE
  fitting_guide_help_text: null,
  fitting_guide_small: null,
  fitting_guide_perfect: null,
  fitting_guide_large: null,
  fitting_guide_runs_small_size_up: null,
  fitting_guide_between_small_true: null,
  fitting_guide_true_to_size: null,
  fitting_guide_between_large_true: null,
  fitting_guide_runs_large_size_down: null,
  // BUNDLE
  bundle_title: null,
  bundle_select_size: null,
  bundle_validate_size_error: null,
  bundle_quickadd: null,
  bundle_item_added: null,
  bundle_products: null,
  // FEATURES ICONS
  icons_list: null,
  // PRODUCT REVIEWS
  product_reviews_tab_title: null,
  product_reviews_leave_review: null,
  product_reviews_see_more: null,
  product_reviews_see_others_countries: null,
  product_reviews_product_size: null,
  product_reviews_usual_size: null,
  product_reviews_customer_height: null,
  product_reviews_no_rating: null,
  // ADD REVIEW
  addreview_tab_title: null,
  addreview_review_for: null,
  addreview_product_rating: null,
  addreview_displayname: null,
  addreview_email: null,
  addreview_review_title: null,
  addreview_review_content: null,
  addreview_product_size: null,
  addreview_usual_size: null,
  addreview_customer_height: null,
  addreview_submit: null,
  addreview_terms: null,
  // FEATURES LIST
  features_list: null,
  // CAROUSEL BESTSELLERS
  carousel_bottom_collection_handle: null,
  carousel_bottom_title: null,
  carousel_bottom_nbProducts: null,
  carousel_bottom_nbProducts_mobile: null,
  // CAROUSEL CATEGORY
  carousel_category_title: null,
  carousel_category_isActive: null,
  carousel_category_nbProducts: null,
  carousel_category_nbProducts_mobile: null,
}
